import { QueryClient } from "@tanstack/react-query";
import { createRouter, createBrowserHistory } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

const ONE_DAY = 24 * 60 * 60 * 1000;

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { gcTime: ONE_DAY } },
  });
  const browserHistory = createBrowserHistory();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    history: browserHistory,
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
